module.exports = __webpack_public_path__ + "static/openbci-beginning-83930a156944b407bc477e418c9379cd.jpg";